import { TextArea } from '../form'
import { TplGroup } from './index'
import { Field } from 'formik'

const Textarea = ({ name, title, placeholder, isRequired, tabIndex, disabled, ...el }: any) => {
  return (
    <TplGroup name={name} title={title} isRequired={isRequired}>
      <Field
        name={name}
        placeholder={placeholder || ''}
        tabIndex={tabIndex}
        disabled={!!disabled}
        as={TextArea}
        onChange={(val: any) => {
          if (el.setFieldValue) {
            el.setFieldValue(name, val.target.value)
          }
        }}
      />
    </TplGroup>
  )
}

export default Textarea
